import { dir } from "i18next";
import {
  getButtonTypes,
  getAccountUsersList,
  saveButtonsData,
  getLinesInfo,
  getBlfGroupsInButtonsUI
} from "../../../apiclients/streamsapi_bridge.js";
let helper = {};
helper.getButtonsDropDown = function (siteid) {
  return new Promise(async (resolve) => {
    try {
      let response = await getButtonTypes(siteid);
      if (response.ok) {
        resolve(await response.json());
      } else {
        resolve([]);
      }
    } catch (e) {
      console.error("Exception in getButtonsDropDown " + e);
    }
  });
};

helper.getAccountUsersList = async function (siteid) {
  return new Promise(async (resolve) => {
    let response = await getAccountUsersList(siteid);
    if (response.ok) {
      let [telephonyUsersList, pbxUserList] = await response.json();
      if (pbxUserList.length > 0) {
        pbxUserList = pbxUserList
          .map((item, index) => {
            if (
              item.firstname &&
              item.firstname != "" &&
              item.lastname &&
              item.lastname != "" &&
              item.extensions &&
              item.extensions != ""
            ) {
              item = {
                text:
                  item.firstname + " " + item.lastname + ": " + item.extensions,
                value: item.id,
                label: item.firstname + " " + item.lastname
              };
              return item;
            }
          })
          .filter((item) => item != undefined);

        pbxUserList.unshift({ text: "Select user", value: "" });
      }
      resolve([telephonyUsersList, pbxUserList]);
    } else {
      resolve([]);
    }
  });
};

helper.saveButtonsData = async function (siteid, buttonsData, blf_groups) {
  try {
    let deviceData = buttonsData.deviceData;
    let mac_address = deviceData.macaddress;
    let devicename = deviceData?.devicename
    let dirtyFields = buttonsData.dirtyFields;
    let linesMap = buttonsData.linesMap;
    let data = buttonsData.list;
    let listToSave = [];
    let blfgroupValidator = [];
    if (dirtyFields?.dataList) {
      dirtyFields.dataList.map((buttonInfo, index) => {
        if (index >= 0 && index <= deviceData.nolines_supported) {
          let button = data.dataList[index];
          if (!button.hasOwnProperty("MLA_DUMMY")) {
            button.button_no = index + 1;
            if (button && linesMap.get(button.button_no)) {
              button.isNew = false;
              listToSave.push(button);
            } else if (button) {
              button.isNew = true;
              listToSave.push(button);
            }
          }
        }
      });
    }

    console.log("Final list to Save is : ");
    console.dir(listToSave);

    //remove dublicates 
    if(data?.dataList?.length > 0 ) {
      data.dataList[0].designation = deviceData.designation === "IP Phone 1" ? 1 : 2;
    }
    let jo = { mac_address: mac_address, list: listToSave, total_buttons_list: data.dataList,devicename:devicename };
    let response = await saveButtonsData(siteid, jo);
    console.log("Response from saveButtonsData: " + response.status);
    if (response.status == 200) {
      let linesList = await response.json();
      let seq = generateSequence(1, deviceData.nolines_supported);
      let linesMap = new Map(linesList.map((obj) => [obj.button_no, obj]));
      let jo = {};
      jo.button_no = 1;
      jo.button_type = 1;
      jo.user_or_value = deviceData.userPBXid;
      jo.user_value_name = deviceData.userName + ": " + deviceData.extension;
      jo.label = deviceData.userName;
      jo.ring_type = 1;
      let defaultLinesList = [jo];
      let defaultLinesMap = new Map(
        defaultLinesList.map((obj) => [obj.button_no, obj])
      );


      if (linesList.length > 0) {
        linesMap = new Map(linesList.map((obj) => [obj.button_no, obj]));
        if (!linesMap.get(1)) {
          // If Line 1 information is not available in DB then show the default device information at line 1.
          linesList.splice(0, 0, jo);
          linesMap = new Map(linesList.map((obj) => [obj.button_no, obj]));
          console.dir(linesList);
        }
      } else {
        linesList = defaultLinesList;
        linesMap = defaultLinesMap;
      }

      var uniqueMap = new Map();

      for (var i = 1; i <= seq.length; i++) {
        // console.log("sequence value is : " + i);
        if (!linesMap.get(i)) {
          linesList.splice(i - 1, 0, {
            button_no: i,
            button_type: 6,
            user_or_value: "",
            user_value_name: "",
            label: "",
            no_of_mla_lines: 0,
            ring_type: 1,
            index: i - 1,
            blf_group_id: 0,
            blf_error: 0
          });
          // console.log("after modifying...linesList:  ");
          //console.dir(linesList);
        } else {

          //check if MLA is enabled for this line.
          let lineObj = linesMap.get(i);
          if (lineObj.custom * 1 == 1) {
            lineObj.custom_did_value = lineObj.user_or_value;
            lineObj.custom_type = 1;
          }

          if (lineObj.user_or_value) {
            uniqueMap.set(lineObj.user_or_value.toString(), lineObj);
          }
          if (lineObj?.no_of_mla_lines * 1 > 0) {
            setDuplicateLines(i, lineObj, linesList);
            i = i + (lineObj?.no_of_mla_lines * 1 - 1);
          }
          // else if (lineObj.blf_group_id !== 0) {
          //   let insertItems = setBlfgroupLines(lineObj, blf_groups, i, linesList, deviceData.nolines_supported, uniqueMap);
          //   i = insertItems
          //   //linesList[i - 1] = { ...lineObj, index: i - 1 }
          // }
          else {
            linesList[i - 1] = { ...lineObj, index: i - 1 }
          }
        }
      }

      console.log("Save response linesList: " + JSON.stringify(linesList));

      return [linesList, linesMap];

    }else{
      console.error("Error in saveButtonsData: " + response.statusText);
      return [[], []];
    }
  } catch (e) {
    console.error("Exception in saveButtonsData " + e);
  }
  return [];
};

function setBlfgroupLines(lineObj, blf_GroupsInfo, idx, linesList, lines_supported, uniqueMap) {
  try {

    idx = idx * 1;

    console.log("need to insert index : " + idx + ", lineObj :" + lineObj + " ,blf_groups :" + blf_GroupsInfo);

    let blf_length = blf_GroupsInfo.length;
    // let filteredGroup = removeDuplicateUsers(linesList, blf_GroupsInfo[lineObj.blf_group_id], idx);
    let blfgroup = blf_GroupsInfo[lineObj.blf_group_id];
    console.log("Actual blfGroup :" + JSON.stringify(blfgroup));
    let group = [];

    blfgroup.forEach((grp) => {
      if (!uniqueMap.get(grp.user_or_value.toString())) {
        group.push(grp);
      }
    });

    console.log("extracted BlfGroup :" + JSON.stringify(group));

    let currentButton = linesList[idx - 1].button_no;

    let nextButton = linesList[idx] ? linesList[idx].button_no : lines_supported;

    let fitButtons = nextButton * 1 - currentButton * 1;
    console.log("next button is : " + fitButtons + ": " + group.length);
    //fitButtons = fitButtons - group.length;
    console.log("fitButtons :" + fitButtons + " ,index start :" + (idx - 1) + ",index ends :" + (idx + fitButtons - 1));
    let grpIndex = 1;


    let length = 0;
    if (group.length <= fitButtons) {
      length = group.length;
    } else {
      length = fitButtons;
    }

    for (let i = idx - 1; i < idx + length - 1; i++) {
      if (i == (idx - 1)) {
        linesList[i] = { ...lineObj, ...group[0], "index": i, "button_no": i + 1 }   //updating object
        uniqueMap.set(linesList[i].user_or_value.toString(), linesList[i]);
      } else {
        let object = { ...lineObj, ...group[grpIndex], "index": i, "button_no": i + 1 }
        linesList.splice(i, 0, object);      //adding object 
        uniqueMap.set(object.user_or_value.toString(), object);
        grpIndex++;
      }
    }

    return idx + length - 1;

  } catch (e) {
    console.log("Error in setBlfgroupLines :" + e);
  }
}

helper.getLinesInfo = async function (siteid, deviceData, blf_GroupsInfo) {
  //console.log("[getLinesInfo] BlfGroups:::::::::" + JSON.stringify(blf_GroupsInfo));
  return new Promise(async (resolve) => {
    let response = await getLinesInfo(siteid, {
      mac_address: deviceData.macaddress,
    });
    let linesList = {};
    let linesMap = {};
    let seq = generateSequence(1, deviceData.nolines_supported);

    let jo = {};
    jo.button_no = 1;
    jo.button_type = 1;
    jo.user_or_value = deviceData.userPBXid;
    jo.user_value_name = deviceData.userName + ": " + deviceData.extension;
    jo.label = deviceData.extension;
    jo.ring_type = 1;
    jo.blf_group_id = 0;
    jo.no_of_mla_lines = deviceData.mla_supported ==  1 ? 2 : 1;
    jo.designation = deviceData.designation === "IP Phone 1" ? 1 : 2
    let defaultLinesList = [jo];
    let defaultLinesMap = new Map(
      defaultLinesList.map((obj) => [obj.button_no, obj])
    );
    if (response.ok) {
      linesList = await response.json();
      if (linesList.length > 0) {
        linesList = linesList.map((button) => { return { ...button, label: button.label.slice(0, 24) } })
        linesMap = new Map(linesList.map((obj) => [obj.button_no, obj]));
        if (!linesMap.get(1)) {
          // If Line 1 information is not available in DB then show the default device information at line 1.
          linesList.splice(0, 0, jo);
          linesMap = new Map(linesList.map((obj) => [obj.button_no, obj]));
          console.dir(linesList);
        }
      } else {
        linesList = defaultLinesList;
        linesMap = defaultLinesMap;
      }
    } else {
      linesList = defaultLinesList;
      linesMap = defaultLinesMap;
    }

    var uniqueMap = new Map();
    for (var i = 1; i <= seq.length; i++) {
      // console.log("sequence value is : " + i);
      if (!linesMap.get(i)) {
        linesList.splice(i - 1, 0, {
          button_no: i,
          button_type: 6,
          user_or_value: "",
          user_value_name: "",
          label: "",
          no_of_mla_lines: 0,
          ring_type: 1,
          index: i - 1,
          blf_group_id: 0,
          blf_error: 0
        });
      } else {


        //check if MLA is enabled for this line.
        let lineObj = linesMap.get(i);

        if (lineObj.user_or_value) {
          uniqueMap.set(lineObj.user_or_value.toString(), lineObj);
        }

        if (lineObj?.no_of_mla_lines * 1 > 0) {
          linesList[i - 1] = { ...lineObj, index: i - 1 }
          setDuplicateLines(i, lineObj, linesList);
          i = i + (lineObj?.no_of_mla_lines * 1 - 1);
        }
        //  else if (lineObj.blf_group_id !== 0) {
        //   let insertItems = setBlfgroupLines(lineObj, blf_GroupsInfo, i, linesList, deviceData.nolines_supported, uniqueMap);
        //   i = insertItems;

        //   //linesList[i - 1] = { ...lineObj, index: i - 1 }
        // }
        else {
          linesList[i - 1] = { ...lineObj, index: i - 1 }
        }
      }
    };
    //console.log("helper.getLinesInfo ::::::::" + JSON.stringify(linesList));
    resolve([linesList, linesMap]);
  });
};

function setDuplicateLines(index, lineObj, linesList) {
  try {
    for (var i = 0; i < lineObj?.no_of_mla_lines * 1 - 1; i++) {
      lineObj = { ...lineObj, "button_no": lineObj.button_no + 1, "MLA_DUMMY": true, index: index + i, button_ref: index - 1 }
      //console.log("in loop index is : "+index+" "+(index+i));
      linesList.splice(index + i, 0, lineObj);
    }
  } catch (e) {
    console.log("Error in duplicateLines: " + e);
  }
}

function generateSequence(start, end) {
  const seq = [];
  for (let i = start; i <= end; i++) {
    seq.push(i);
  }
  return seq;
}
helper.getBlfGroupsInfo = async (siteid, mac) => {
  try {
    console.log("Requesting server fo BLFGroups :" + siteid);
    var blf_groups = {};

    let apires = await getBlfGroupsInButtonsUI(siteid, { macadress: mac });
    if (!apires.ok) {
      console.log("Notwork server response is not OK!!!!!!!!")
    } else {
      blf_groups = await apires.json();
      console.log("Server response for BLF_groups:" + JSON.stringify(blf_groups));
    }
    return blf_groups;
  } catch (e) {
    console.log("Error in getBlfGroupsInfo");
  }

}
export default helper;
